/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FixIt API
 * Real-time service marketplace API

## Date & time contract

- **Instants** are ISO-8601 UTC ending in `Z` (`format: date-time`); every `*At` field is an instant.
- **Civil days** are bare `YYYY-MM-DD` (`format: date`) and mean that calendar day in the resource's attribution zone (company/contract zone, default Europe/Prague) - never a UTC or device day.
- **Civil months** are `YYYY-MM`, same anchor.
- **Civil-day range params (`dateFrom`/`dateTo`) are both inclusive** at day granularity - `dateTo=2026-05-31` includes the whole of 31 May.
- **Instant range params** (`from`/`to` taking `Z` instants) are half-open `[from, to)`.
- **DST gaps:** a civil day whose local midnight does not exist in its attribution zone starts at the first existing instant of that day (bounds resolve forward, never into the previous day).
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiErrorResponseDto,
  BozpClientReportDto,
  BozpCompletionResultDto,
  BozpProgressResponseDto,
  BozpSessionResponseDto,
  BozpTrainingResponseDto,
  OpenSessionDto,
  RecordEventDto,
  SubmitCompletionDto
} from '.././models';

import { customInstance } from '../../axios-instance';
import type { ErrorType } from '../../axios-instance';
import { withDefaultQueryOptions } from '../../query-options';




export const bozpTrainingControllerReportClientV1 = (
    bozpClientReportDto: BozpClientReportDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/bozp/client-reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bozpClientReportDto, signal
    },
      );
    }
  


export const getBozpTrainingControllerReportClientV1MutationOptions = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerReportClientV1>>, TError,{data: BozpClientReportDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerReportClientV1>>, TError,{data: BozpClientReportDto}, TContext> => {

const mutationKey = ['bozpTrainingControllerReportClientV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bozpTrainingControllerReportClientV1>>, {data: BozpClientReportDto}> = (props) => {
          const {data} = props ?? {};

          return  bozpTrainingControllerReportClientV1(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BozpTrainingControllerReportClientV1MutationResult = NonNullable<Awaited<ReturnType<typeof bozpTrainingControllerReportClientV1>>>
    export type BozpTrainingControllerReportClientV1MutationBody = BozpClientReportDto
    export type BozpTrainingControllerReportClientV1MutationError = ErrorType<ApiErrorResponseDto>

    export const useBozpTrainingControllerReportClientV1 = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerReportClientV1>>, TError,{data: BozpClientReportDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bozpTrainingControllerReportClientV1>>,
        TError,
        {data: BozpClientReportDto},
        TContext
      > => {

      const mutationOptions = getBozpTrainingControllerReportClientV1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const bozpTrainingControllerCompleteV1 = (
    submitCompletionDto: SubmitCompletionDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BozpCompletionResultDto>(
      {url: `/api/v1/bozp/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitCompletionDto, signal
    },
      );
    }
  


export const getBozpTrainingControllerCompleteV1MutationOptions = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerCompleteV1>>, TError,{data: SubmitCompletionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerCompleteV1>>, TError,{data: SubmitCompletionDto}, TContext> => {

const mutationKey = ['bozpTrainingControllerCompleteV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bozpTrainingControllerCompleteV1>>, {data: SubmitCompletionDto}> = (props) => {
          const {data} = props ?? {};

          return  bozpTrainingControllerCompleteV1(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BozpTrainingControllerCompleteV1MutationResult = NonNullable<Awaited<ReturnType<typeof bozpTrainingControllerCompleteV1>>>
    export type BozpTrainingControllerCompleteV1MutationBody = SubmitCompletionDto
    export type BozpTrainingControllerCompleteV1MutationError = ErrorType<ApiErrorResponseDto>

    export const useBozpTrainingControllerCompleteV1 = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerCompleteV1>>, TError,{data: SubmitCompletionDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bozpTrainingControllerCompleteV1>>,
        TError,
        {data: SubmitCompletionDto},
        TContext
      > => {

      const mutationOptions = getBozpTrainingControllerCompleteV1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const bozpTrainingControllerRecordEventV1 = (
    recordEventDto: RecordEventDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/bozp/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordEventDto, signal
    },
      );
    }
  


export const getBozpTrainingControllerRecordEventV1MutationOptions = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerRecordEventV1>>, TError,{data: RecordEventDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerRecordEventV1>>, TError,{data: RecordEventDto}, TContext> => {

const mutationKey = ['bozpTrainingControllerRecordEventV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bozpTrainingControllerRecordEventV1>>, {data: RecordEventDto}> = (props) => {
          const {data} = props ?? {};

          return  bozpTrainingControllerRecordEventV1(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BozpTrainingControllerRecordEventV1MutationResult = NonNullable<Awaited<ReturnType<typeof bozpTrainingControllerRecordEventV1>>>
    export type BozpTrainingControllerRecordEventV1MutationBody = RecordEventDto
    export type BozpTrainingControllerRecordEventV1MutationError = ErrorType<ApiErrorResponseDto>

    export const useBozpTrainingControllerRecordEventV1 = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerRecordEventV1>>, TError,{data: RecordEventDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bozpTrainingControllerRecordEventV1>>,
        TError,
        {data: RecordEventDto},
        TContext
      > => {

      const mutationOptions = getBozpTrainingControllerRecordEventV1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const bozpTrainingControllerGetProgressV1 = (
    hazardProfileId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BozpProgressResponseDto>(
      {url: `/api/v1/bozp/progress/${hazardProfileId}`, method: 'GET', signal
    },
      );
    }
  



export const getBozpTrainingControllerGetProgressV1QueryKey = (hazardProfileId?: string,) => {
    return [
    `/api/v1/bozp/progress/${hazardProfileId}`
    ] as const;
    }

    
export const useBozpTrainingControllerGetProgressV1QueryOptions = <TData = Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError = ErrorType<ApiErrorResponseDto>>(hazardProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBozpTrainingControllerGetProgressV1QueryKey(hazardProfileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>> = ({ signal }) => bozpTrainingControllerGetProgressV1(hazardProfileId, signal);

      

      const customOptions = withDefaultQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BozpTrainingControllerGetProgressV1QueryResult = NonNullable<Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>>
export type BozpTrainingControllerGetProgressV1QueryError = ErrorType<ApiErrorResponseDto>


export function useBozpTrainingControllerGetProgressV1<TData = Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError = ErrorType<ApiErrorResponseDto>>(
 hazardProfileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>,
          TError,
          Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBozpTrainingControllerGetProgressV1<TData = Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError = ErrorType<ApiErrorResponseDto>>(
 hazardProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>,
          TError,
          Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBozpTrainingControllerGetProgressV1<TData = Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError = ErrorType<ApiErrorResponseDto>>(
 hazardProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBozpTrainingControllerGetProgressV1<TData = Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError = ErrorType<ApiErrorResponseDto>>(
 hazardProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetProgressV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useBozpTrainingControllerGetProgressV1QueryOptions(hazardProfileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const bozpTrainingControllerOpenSessionV1 = (
    openSessionDto: OpenSessionDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BozpSessionResponseDto>(
      {url: `/api/v1/bozp/sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: openSessionDto, signal
    },
      );
    }
  


export const getBozpTrainingControllerOpenSessionV1MutationOptions = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerOpenSessionV1>>, TError,{data: OpenSessionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerOpenSessionV1>>, TError,{data: OpenSessionDto}, TContext> => {

const mutationKey = ['bozpTrainingControllerOpenSessionV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bozpTrainingControllerOpenSessionV1>>, {data: OpenSessionDto}> = (props) => {
          const {data} = props ?? {};

          return  bozpTrainingControllerOpenSessionV1(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BozpTrainingControllerOpenSessionV1MutationResult = NonNullable<Awaited<ReturnType<typeof bozpTrainingControllerOpenSessionV1>>>
    export type BozpTrainingControllerOpenSessionV1MutationBody = OpenSessionDto
    export type BozpTrainingControllerOpenSessionV1MutationError = ErrorType<ApiErrorResponseDto>

    export const useBozpTrainingControllerOpenSessionV1 = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpTrainingControllerOpenSessionV1>>, TError,{data: OpenSessionDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bozpTrainingControllerOpenSessionV1>>,
        TError,
        {data: OpenSessionDto},
        TContext
      > => {

      const mutationOptions = getBozpTrainingControllerOpenSessionV1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const bozpTrainingControllerGetTrainingV1 = (
    hazardProfileId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BozpTrainingResponseDto>(
      {url: `/api/v1/bozp/training/${hazardProfileId}`, method: 'GET', signal
    },
      );
    }
  



export const getBozpTrainingControllerGetTrainingV1QueryKey = (hazardProfileId?: string,) => {
    return [
    `/api/v1/bozp/training/${hazardProfileId}`
    ] as const;
    }

    
export const useBozpTrainingControllerGetTrainingV1QueryOptions = <TData = Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError = ErrorType<ApiErrorResponseDto>>(hazardProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBozpTrainingControllerGetTrainingV1QueryKey(hazardProfileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>> = ({ signal }) => bozpTrainingControllerGetTrainingV1(hazardProfileId, signal);

      

      const customOptions = withDefaultQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BozpTrainingControllerGetTrainingV1QueryResult = NonNullable<Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>>
export type BozpTrainingControllerGetTrainingV1QueryError = ErrorType<ApiErrorResponseDto>


export function useBozpTrainingControllerGetTrainingV1<TData = Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError = ErrorType<ApiErrorResponseDto>>(
 hazardProfileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>,
          TError,
          Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBozpTrainingControllerGetTrainingV1<TData = Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError = ErrorType<ApiErrorResponseDto>>(
 hazardProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>,
          TError,
          Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBozpTrainingControllerGetTrainingV1<TData = Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError = ErrorType<ApiErrorResponseDto>>(
 hazardProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBozpTrainingControllerGetTrainingV1<TData = Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError = ErrorType<ApiErrorResponseDto>>(
 hazardProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bozpTrainingControllerGetTrainingV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useBozpTrainingControllerGetTrainingV1QueryOptions(hazardProfileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




